export type RequestError = {
  message: string;
  code: number;
  data?: any;
} | null;

const normalizeRequestError = (error: any, passthroughErrorCodes: number[]): Exclude<RequestError, null> => {
  const rawCode = error?.httpCode;
  const code = typeof rawCode === 'number' || typeof rawCode === 'string' ? Number(rawCode) : NaN;
  return {
    message: 'request fail',
    code: passthroughErrorCodes.includes(code) ? code : -1,
  };
};
interface RequestOptions {
  url: string;
  passthroughErrorCodes?: number[];
  // ----- mpweb适配origin -----
  // ----- mpweb适配change -----
  headers?: Record<string, any>;
  // ----- mpweb适配       -----
  data?: {
    [key: string]: any;
  };
}
interface Params {
  url: string;
  method: string;
  data: any;
  params: any;
  dataType: string;
  headers?: {
    [key: string]: any;
  };
}
const request = (method: 'POST' | 'GET') => <T>(opions: RequestOptions): Promise<[null, T] | [RequestError]> => {
  const Network = Mach.requireModule('Network');
  return new Promise((resolve) => {
    // ----- mpweb适配origin -----
    // const { url, data = null, passthroughErrorCodes = [] } = opions;
    // ----- mpweb适配change -----
    const {
      url,
      data = null,
      passthroughErrorCodes = [],
      headers,
    } = opions;
    // ----- mpweb适配       -----
    const params: Params = {
      url,
      method,
      data: null,
      params: null,
      dataType: 'json',
    };
    // ----- mpweb适配origin -----
    // ----- mpweb适配change -----
    params.headers = headers;
    // ----- mpweb适配       -----
    if (method === 'GET') {
      params.params = data;
    } else {
      params.data = data;
    }
    Network.request(params, (result) => {
      const { data: responseData, error } = result;
      if (!error) {
        const { message = '', data: rawData, code } = responseData || {};
        if (code === 0) {
          resolve([null, rawData]);
        } else {
          resolve([{ message, code, data: rawData }]);
        }
        return;
      }
      resolve([normalizeRequestError(error, passthroughErrorCodes)]);
    });
  });
};

const $post = request('POST');
const $get = request('GET');
export { $post, $get };
